import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIRecommendationChoiceWrapper } from './components/AIRecommendationChoiceWrapper';

async function LoadAIRecommendationChoiceStep(): Promise<typeof AIRecommendationChoiceWrapper> {
	return (
		await import(
			/* webpackChunkName: "pages/start-a-petition-steps-ai-recommendation-choice" */ './components/AIRecommendationChoiceWrapper'
		)
	).AIRecommendationChoiceWrapper;
}

export function AIRecommendationChoiceLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAIRecommendationChoiceStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAIRecommendationChoiceStep = LoadAIRecommendationChoiceStep;
